"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TxSideNavComponent = /** @class */ (function () {
    function TxSideNavComponent() {
    }
    TxSideNavComponent.prototype.ngOnInit = function () {
    };
    TxSideNavComponent.ctorParameters = function () { return []; };
    return TxSideNavComponent;
}());
exports.TxSideNavComponent = TxSideNavComponent;
//# sourceMappingURL=tx-side-nav.component.js.map


// WEBPACK FOOTER //
// tx-side-nav.component.js